import * as React from "react";

import DeprecatedButton from "@v1/components/designSystem/button/Button";
import { Modal } from "@v1/components/designSystem/modal/Modal";
import { routes } from "@v2/utils/router";

/**
 * Layout shown when a user tries to access a project they don't have access to.
 *
 * @author Noah 2026-01-14
 */
const NoAccessToProjectLayout = () => {
  return (
    <div id="app" className="bg-surface h-screen w-full">
      <Modal
        isOpen={true}
        onOpenChange={() => {}}
        title="Request access to this project"
        description="You don't have access to this Replo project."
        size="sm"
        closeOnOverlayClick={false}
        footer={
          <DeprecatedButton variant="primary" size="base" to={routes.home.root}>
            Back to Dashboard
          </DeprecatedButton>
        }
      >
        <p className="text-sm">
          Please request access from the project admin. You can view this
          project once your request is approved.
        </p>
      </Modal>
    </div>
  );
};

export default NoAccessToProjectLayout;
